import React, { useEffect, useState } from "react";
import SectionHeading from "./sectionHeading";
import { Button } from "@speedoc/design-assets";
import useGoogleMapsApi from "../../hooks/useGoogleApi";
import GMap from "../../utils/googleMap";
import { GlobalStore } from "../../stores/global";
import { useMediaQuery } from "react-responsive";

export default function LocationMapView({ content }) {
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);
  const isMobile = useMediaQuery({ query: "(max-width: 1100px)" });
  const geocoder = useGoogleMapsApi();
  const [activeIndex, setActiveIndex] = useState(
    countryCode.toLowerCase() === "sg" ? 0 : countryCode.toLowerCase() === "my" ? 1 : 0
  );
  const [location, setLocation] = useState(
    countryCode.toLowerCase() === "sg"
      ? { lat: 1.2736066, lng: 103.8042185 }
      : countryCode.toLowerCase() === "my"
      ? { lat: 3.1348877660013104, lng: 101.62988406694605 }
      : { lat: 1.2736066, lng: 103.8042185 }
  );
  const buttonDetails = content?.listCountry.map((tab, i) => {
    return {
      ...tab,
      classes: `secondary sm ${activeIndex === i ? "active" : ""}`
    };
  });

  useEffect(() => {
    if (content.listCountry.length && geocoder) {
      const request = { address: content?.listCountry[activeIndex].location };
      const gc = new geocoder.Geocoder();
      gc.geocode(request)
        .then(result => {
          const { results } = result;
          const geoLocation = results[0].geometry.location;
          setLocation({
            lat: geoLocation.lat(),
            lng: geoLocation.lng()
          });
        })
        .catch(e => {
          console.log(e);
        });
    }
  }, [content, activeIndex]);

  function renderTabs(tabDetails) {
    return (
      <div className="tabsMasterContainer">
        <div className="tabsContainer">
          <div className="tabs">
            {tabDetails &&
              tabDetails.length &&
              tabDetails.map(({ name, classes }, i) => (
                <div key={i}>
                  <Button
                    onClick={() => {
                      setActiveIndex(i);
                    }}
                    className={classes || "secondary sm"}>
                    {name}
                  </Button>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="locationMapView">
      <SectionHeading subtitle={content.subtitle} title={content.title} />
      {!isMobile && renderTabs(buttonDetails)}
      <div className="content">
        <div className="contentLeft">
          {isMobile && renderTabs(buttonDetails)}
          <div className="contentTabs" dangerouslySetInnerHTML={{ __html: content?.listCountry[activeIndex].info }} />
        </div>
        <div className="contentRight">
          <div className="mapView">
            {geocoder && (
              <GMap
                location={location}
                zoom={16}
                containerElement={<div className="containerElement" />}
                mapElement={<div className="mapElement" />}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
